import '@src/@core/scss/spaccurate-custom/navbar-user.scss';
import { LogIn, Home, Gift } from 'react-feather';
import { Button, NavItem, NavLink, UncontrolledTooltip } from 'reactstrap';
import { isUserLoggedIn } from '@src/auth/utils';
import themeConfig from '@src/configs/themeConfig';
import { useHistory } from 'react-router-dom';
import UserDropdown from './UserDropdown';

const NavbarUser = () => {
  // const { skin, setSkin } = props;
  const history = useHistory();

  // ** Function to toggle Theme (Light/Dark)
  // const ThemeToggler = () => {
  //   if (skin === 'dark') {
  //     return <Sun className="ficon" onClick={() => setSkin('light')} />;
  //   }
  //   return <Moon className="ficon" onClick={() => setSkin('dark')} />;
  // };

  return (
    <>
      <div className="bookmark-wrapper d-flex align-items-center justify-content-end">
        {/* <NavItem className="d-none d-sm-block">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem> */}
        <NavItem className="d-none d-sm-block">
          <NavLink className="nav-link-style">
            <Home
              id="locations"
              className="ficon navbar-user-providers-icon"
              onClick={() => history.push('')}
            />
            <UncontrolledTooltip placement="auto" target="locations">
              Locations
            </UncontrolledTooltip>
          </NavLink>
        </NavItem>
        <NavItem className="d-none d-sm-block">
          <NavLink className="nav-link-style">
            <Gift
              id="gift-cards"
              className="ficon navbar-user-providers-icon"
              onClick={() => {
                history.push(`/gift-card`);
              }}
            />
            <UncontrolledTooltip placement="auto" target="gift-cards">
              Gift Cards
            </UncontrolledTooltip>
          </NavLink>
        </NavItem>
      </div>
      <div className="d-flex brand-logo d-block d-sm-none ms-50">
        <img
          className="brand-text mt-50"
          width={140}
          src={themeConfig.app.appLogoImage}
          alt="logo"
        />
      </div>
      <ul className="nav navbar-nav align-items-center ms-auto">
        {/* <NavItem className="d-block d-sm-none">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem> */}
        {isUserLoggedIn() ? (
          <UserDropdown />
        ) : (
          <Button
            className="d-sm-block d-none"
            color="primary"
            outline
            onClick={() => history.push('/login')}
          >
            <span className="align-middle">Sign In</span>
            <LogIn size={14} className="align-middle ms-25" />
          </Button>
        )}
      </ul>
    </>
  );
};
export default NavbarUser;
